import { render, staticRenderFns } from "./gateways.vue?vue&type=template&id=3b1dbab2"
import script from "./gateways.vue?vue&type=script&lang=js"
export * from "./gateways.vue?vue&type=script&lang=js"
import style0 from "./gateways.vue?vue&type=style&index=0&id=3b1dbab2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports